module.exports = __webpack_public_path__ + "img/206.kitchen.02ecfd65.svg";